var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon icon--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }